import { useMutation, useQueryClient } from 'react-query';

import type { IStandardErrorResponse } from 'src/api/common';
import { useNotifications } from 'src/notifications';
import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api/client';
import { API_INBOXES_PATH } from 'src/services/api/inboxes/constants';

export const useDeleteInbox = () => {
    const queryClient = useQueryClient();
    const { addNotification } = useNotifications();

    return useMutation<undefined, IStandardErrorResponse, number>(
        async (id) => {
            return apiClient(`${API_INBOXES_PATH}/${id}`, {
                method: 'delete'
            }).json();
        }, {
            onSuccess: () => {
                addNotification('Inbox deleted', 'success');
                queryClient.invalidateQueries([queryKeys.inboxes]);
                queryClient.invalidateQueries([queryKeys.inboxFavorites]);
            }, onError: (error) => {
                const schemaValidationError = error?.messages?.map(message => message.msg).join(', ');
                console.error('Failed to delete inbox', error);
                const errorMessage = schemaValidationError || error.msg || 'Failed to delete inbox';
                addNotification(errorMessage, 'error');
            }
        }
    );
};
